import React, { useEffect } from "react";
import { } from 'react-redux';
import { } from "react-i18next";

import './css/index.scss';

import {
} from '@lockerpm/design';

import commonComponents from "../../components/common";

import global from "../../config/global";
import authServices from "../../services/auth";

const Authenticate = () => {
  const { BusyOverlay } = commonComponents;

  useEffect(() => {
    loginWithToken();
  }, [])

  const loginWithToken = async () => {
    const token = authServices.cs_locker_token();
    if (token) {
      authServices.update_access_token(token);
      await authServices.locker_access_token().then(async (response) => {
        authServices.update_access_token(response.access_token);
        global.navigate('LOCK')
      }).catch(() => {
        authServices.update_access_token(null);
      })
    } else {
      global.navigate('LOGIN')
    }
  }
  return (
    <div className="auth-page">
      <BusyOverlay />
    </div>
  );
}

export default Authenticate;